<template>
  <div class="bg-contain common-blue-contain base_main">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{$t('callInfo')}}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('userNameH')" v-if="!userId">
            <el-input v-model="formInline.userName" clearable placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('appName')">
            <el-input v-model="formInline.appName" clearable placeholder="$t('appName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Recordtime')" class="datetime">
            <el-date-picker
              v-model="formInline.searchTimeB"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.searchTimeE"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" @click="getList">{{ $t('query') }}</el-button>
            <el-button
              type="primary"
              class="serachBtn letter_delet"
              @click="handleDelet"
              v-has="'sys:new:setting:log:data:delete'"
              >{{ $t('batchDelete') }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="total-flow">
        <span
          >{{ $t('sumCallDuration') }}：<i class="log-num">{{ statisData.sum_of_duration }}</i></span
        >
        <span
          >{{ $t('avgCallDuration') }}：<i class="log-num">{{ statisData.avg_of_duration }}</i></span
        >
      </div>
      <!-- table组件 -->
      <div class="table-box">
        <Table
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :type="type"
          @getList="getList"
          @operate="operationEvent"
          :currentPage="currentPage"
          :pageSize="pageSize"
          ref="tanleAssembly"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// 引入table组件
import Table from '@/components/NewTable'
import { getCalls, deleteCallLog, mediaUploadAppNames } from '@/api/log'
export default {
  // 实时监控》历史记录》组件弹窗传用户名
  props: {
    userId: {
      type: String,
    },
  },
  data() {
    return {
      // 表单查询字段
      formInline: {
        userName: '',
        appName: '',
        searchTimeB: '',
        searchTimeE: '',
      },
      // 当前页
      currentPage: 1,
      // 当前 10条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      // 通话总/平均数据
      statisData: {},
      // 用于批量删除 公共组件类型判断
      type: 'call',
      // 查询 ’应用程序‘的数据
      appNames: [],
    }
  },
  components: {
    Table,
  },
  methods: {
    // 批量删除
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._deleteCallLog(row)
      }
    },
    //  删除日志
    _deleteCallLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          userId: row.value.userId,
          sid: row.value.sid,
          logTimestamp: row.value.logTimestamp,
        }
        deleteCallLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      // 清空批量选择的数据
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.basicConfig()
    },
    // 基础配置数据
    basicConfig() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        userId: this.userId,
      }
      // 获取通话数据
      getCalls(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
          this.statisData = res.value.statistics
        }
      })
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          width: '180',
        },
        {
          attrName: 'duration',
          label: this.$t('callDuration'),
        },
        {
          attrName: 'number',
          label: this.$t('callDuration'),
        },
        {
          attrName: 'status',
          label: this.$t('callStatus'),
        },
        {
          attrName: 'appName',
          label: this.$t('appName'),
        },

        {
          attrName: 'uploadTimestamp',
          label: this.$t('uploadTimestamp'),
          width: '180',
        },
      ]
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: 'sys:new:setting:log:data:delete',
        },
      ]
    },
    // 查询获取媒体上传appNameList
    getAppNames() {
      mediaUploadAppNames().then(res => {
        if (res.state === 0) {
          this.appNames = []
          for (let i = 0; i < res.value.length; i++) {
            this.appNames.push({ value: res.value[i], label: res.value[i] })
          }
        }
      })
    },
  },
  created() {
    this.basicConfig()
    // this.getAppNames()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.total-flow
  margin-bottom 0px
  line-height 36px
  background #f0f9ff
  border: 1px solid var(--border-grey);
  border-bottom: none;
  span
    margin-left 10px
    font-weight: 600
    &:first-child
      margin-left 20px
      .log-num
        color #00cd01
    &:nth-child(2)
      .log-num
        color red
.letter_delet
  margin-left: 10px
// 深色
.theme-dark
  .total-flow
    background #072368
    border: 1px solid #0057A8;
</style>
